const BASE_ROUTE = process.env.REACT_APP_SERVICIO_DE_DATOS_API;

export default BASE_ROUTE;
